/**
 * Application-wide constants
 */

// Daily Planning / Reflect Page
export const BIG_3_LIMIT = 3 // Maximum number of Big 3 tasks to display
export const JOURNAL_MODE_CUTOFF_HOUR = 15 // Hour (24h format) when journal mode switches from morning to evening

// Timezone
export const DEFAULT_TIMEZONE = 'America/New_York' // Fallback timezone when user settings not available

// Archive
export const ARCHIVE_BATCH_SIZE = 50 // Number of archived tasks to render per batch
